import axios from "axios";
import Globais, { validateToken } from "../components/Globais";
import { Caracteristicas } from "../interfaces/Caracteristicas";

export const listarCaracteristicasService = async (): Promise<
  Caracteristicas[]
> => {
  const Token = validateToken();

  if (!Token) return [];

  try {
    const response = await axios.get(`${Globais.DOMINIOBACK}/caracteristicas`, {
      headers: { Authorization: Token.AuthStr },
    });

    return (response?.data as Caracteristicas[]) || [];
  } catch (error) {
    console.error(error);
    return [];
  }
};
